// removed by extract-text-webpack-plugin
module.exports = {"Menu":"FederalLaw__Menu___2XMEM","Additional":"FederalLaw__Additional____FlTk","Title":"FederalLaw__Title___17iAk","Checkboxes":"FederalLaw__Checkboxes___2g3RP","Checkbox":"FederalLaw__Checkbox___1r9_Q","Button":"FederalLaw__Button___2AsXB","FirstColumn":"FederalLaw__FirstColumn___1fWBE","SecondColumn":"FederalLaw__SecondColumn___2_C0f","ThirdColumn":"FederalLaw__ThirdColumn___R1K2F","ButtonWrap":"FederalLaw__ButtonWrap___edyRT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/FederalLaw/FederalLaw.scss
// module id = 1407
// module chunks = 0